// Calendar Configuration - Hong Kong School System
// Academic year structure and scheduling configuration

export const calendarConfig = {
  academicYear: '2024-2025',
  schoolName: '博愛醫院歷屆總理聯誼會梁省德學校',
  schoolNameEn: 'AD&FD POHL Leung Sing Tak School',
  region: 'Hong Kong',
  schoolType: 'Secondary',
  language: ['中文', 'English'],
  calendar: {
    startDate: '2024-09-02',
    endDate: '2025-06-25',
    totalWeeks: 40,
    totalSchoolDays: 190
  }
};

// Term Structure
export const termDates = {
  term1: {
    name: '第一學期',
    nameEn: 'First Term',
    startDate: '2024-09-02',
    endDate: '2025-01-17',
    weeks: 20,
    schoolDays: 95,
    holidays: [
      { name: '中秋節翌日', date: '2024-09-17' },
      { name: '國慶日', date: '2024-10-01' },
      { name: '重陽節', date: '2024-10-11' },
      { name: '聖誕假期', startDate: '2024-12-23', endDate: '2025-01-01' }
    ]
  },
  term2: {
    name: '第二學期',
    nameEn: 'Second Term',
    startDate: '2025-02-17',
    endDate: '2025-06-25',
    weeks: 18,
    schoolDays: 85,
    holidays: [
      { name: '農曆新年', startDate: '2025-01-29', endDate: '2025-02-16' },
      { name: '清明節', date: '2025-04-04' },
      { name: '復活節假期', startDate: '2025-04-18', endDate: '2025-04-21' },
      { name: '勞動節', date: '2025-05-01' },
      { name: '佛誕', date: '2025-05-05' },
      { name: '端午節', date: '2025-06-02' }
    ]
  },
  summerBreak: {
    name: '暑假',
    nameEn: 'Summer Break',
    startDate: '2025-06-26',
    endDate: '2025-08-31',
    weeks: 9,
    summerPrograms: true
  }
};

// Examination Periods
export const examPeriods = {
  uniformTests: [
    {
      id: 'ut1_2024',
      name: '第一次統測',
      nameEn: 'First Uniform Test',
      startDate: '2024-10-15',
      endDate: '2024-10-19',
      term: 1,
      subjects: ['中文', '英文', '數學', '通識', '科學', '地理', '歷史'],
      forms: ['中一', '中二', '中三', '中四', '中五', '中六']
    },
    {
      id: 'ut2_2025',
      name: '第二次統測',
      nameEn: 'Second Uniform Test',
      startDate: '2025-03-15',
      endDate: '2025-03-19',
      term: 2,
      subjects: ['中文', '英文', '數學', '通識', '科學', '地理', '歷史'],
      forms: ['中一', '中二', '中三', '中四', '中五']
    }
  ],
  termExams: [
    {
      id: 'term1_2024',
      name: '第一學期考試',
      nameEn: 'First Term Examination',
      startDate: '2024-12-16',
      endDate: '2024-12-23',
      term: 1,
      subjects: ['中文', '英文', '數學', '通識', '科學', '地理', '歷史', '體育', '音樂', '視藝'],
      forms: ['中一', '中二', '中三', '中四', '中五', '中六']
    },
    {
      id: 'term2_2025',
      name: '第二學期考試',
      nameEn: 'Second Term Examination',
      startDate: '2025-06-10',
      endDate: '2025-06-17',
      term: 2,
      subjects: ['中文', '英文', '數學', '通識', '科學', '地理', '歷史', '體育', '音樂', '視藝'],
      forms: ['中一', '中二', '中三', '中四', '中五']
    }
  ],
  mockExams: [
    {
      id: 'mock_2024',
      name: '中六模擬考試',
      nameEn: 'Form 6 Mock Examination',
      startDate: '2024-11-20',
      endDate: '2024-11-29',
      term: 1,
      subjects: ['中文', '英文', '數學', '通識', '選修科目'],
      forms: ['中六'],
      description: 'DSE模擬考試，為公開考試作準備'
    }
  ]
};

// School Hours and Schedule
export const schoolHours = {
  regular: {
    startTime: '08:00',
    endTime: '15:30',
    periods: 8,
    periodDuration: 40, // minutes
    breakTimes: [
      { name: '小息', time: '09:20-09:35', duration: 15 },
      { name: '午膳', time: '12:30-13:30', duration: 60 },
      { name: '小息', time: '14:50-15:05', duration: 15 }
    ]
  },
  examSchedule: {
    startTime: '08:30',
    endTime: '12:00',
    sessions: [
      { name: '第一節', time: '08:30-10:00', duration: 90 },
      { name: '小息', time: '10:00-10:15', duration: 15 },
      { name: '第二節', time: '10:15-11:45', duration: 90 }
    ]
  },
  halfDay: {
    startTime: '08:00',
    endTime: '12:30',
    periods: 4,
    periodDuration: 40,
    breakTimes: [
      { name: '小息', time: '09:20-09:35', duration: 15 },
      { name: '小息', time: '11:15-11:30', duration: 15 }
    ]
  }
};

// Special Schedules
export const specialSchedules = {
  openingCeremony: {
    date: '2024-09-02',
    name: '開學典禮',
    schedule: {
      startTime: '08:00',
      endTime: '11:30',
      activities: [
        { time: '08:00-08:30', activity: '學生集合及點名' },
        { time: '08:30-09:30', activity: '開學典禮' },
        { time: '09:30-09:45', activity: '小息' },
        { time: '09:45-10:30', activity: '班主任課' },
        { time: '10:30-11:30', activity: '課室整理及迎新活動' }
      ]
    }
  },
  sportsDay: {
    date: '2024-10-25',
    name: '校運會',
    schedule: {
      startTime: '08:00',
      endTime: '16:00',
      activities: [
        { time: '08:00-08:30', activity: '學生集合' },
        { time: '08:30-09:00', activity: '開幕典禮' },
        { time: '09:00-12:00', activity: '田賽及徑賽（上午）' },
        { time: '12:00-13:00', activity: '午膳時間' },
        { time: '13:00-15:30', activity: '田賽及徑賽（下午）' },
        { time: '15:30-16:00', activity: '頒獎典禮' }
      ]
    }
  },
  parentDay: {
    dates: ['2024-09-07', '2024-11-08', '2025-05-20'],
    name: '家長日',
    schedule: {
      startTime: '09:00',
      endTime: '12:00',
      activities: [
        { time: '09:00-09:30', activity: '家長登記及茶點' },
        { time: '09:30-11:30', activity: '家長面談時間' },
        { time: '11:30-12:00', activity: '學校簡報及答問' }
      ]
    }
  },
  graduationCeremony: {
    date: '2025-04-08',
    name: '中六畢業典禮',
    schedule: {
      startTime: '14:00',
      endTime: '17:00',
      activities: [
        { time: '14:00-14:30', activity: '嘉賓及家長入座' },
        { time: '14:30-15:30', activity: '畢業典禮' },
        { time: '15:30-16:00', activity: '茶點招待' },
        { time: '16:00-17:00', activity: '拍照留念' }
      ]
    }
  }
};

// Cycle Days (Hong Kong schools often use cycle day system)
export const cycleDays = {
  cycleLength: 6, // 6-day cycle
  days: [
    { id: 1, name: 'Day 1', color: '#3b82f6' },
    { id: 2, name: 'Day 2', color: '#10b981' },
    { id: 3, name: 'Day 3', color: '#f59e0b' },
    { id: 4, name: 'Day 4', color: '#ef4444' },
    { id: 5, name: 'Day 5', color: '#8b5cf6' },
    { id: 6, name: 'Day 6', color: '#06b6d4' }
  ],
  startDate: '2024-09-03', // First regular school day
  skipDates: [
    // Holidays and special days when cycle doesn't apply
    '2024-09-17', '2024-10-01', '2024-10-11',
    '2024-12-25', '2024-12-26', '2025-01-01',
    '2025-01-29', '2025-01-30', '2025-01-31',
    '2025-04-04', '2025-04-18', '2025-04-19', '2025-04-21',
    '2025-05-01', '2025-05-05', '2025-06-02', '2025-07-01'
  ]
};

// School Calendar Metadata
export const calendarMetadata = {
  lastUpdated: '2024-08-15',
  version: '1.0',
  source: 'Education Bureau Hong Kong',
  notes: [
    '此校曆根據教育局指引制定',
    '如遇特殊情況，學校保留更改權利',
    '詳細時間安排請留意學校通告'
  ],
  contacts: {
    academic: {
      name: '教務處',
      phone: '2345-6789',
      email: 'academic@school.edu.hk'
    },
    student: {
      name: '學生事務處',
      phone: '2345-6790',
      email: 'student@school.edu.hk'
    }
  }
}; 